import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '@env';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    // Authenticated but without any usable role — the token did not resolve to a configured QMS
    // Azure group / App Role, or an admin revoked the account. Send them to the access request
    // page so a first-time user can ask for access instead of hitting a dead end.
    if (auth.hasNoAccess()) {
      return router.createUrlTree(['/request-access']);
    }
    return true;
  }

  // SSO is the only sign-in method when an Azure AD client is configured. Rather than
  // showing an intermediate login page, redirect straight to the Chevron sign-in page so
  // entering the app link signs the user in automatically.
  if (environment.auth.clientId) {
    if (auth.hasMsalAccount()) {
      // An MSAL session exists but resolving the current user failed — surface the error.
      return router.createUrlTree(['/login-failed']);
    }
    auth.loginWithSso();
    return false;
  }

  // No SSO configured (pure local development) — fall back to the mock login picker.
  return router.createUrlTree(['/login']);
};
